"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _VersionsList = _interopRequireDefault(require("../presentational/VersionsList"));

var _actions = require("../actions");

var _actions2 = require("../../componentshell/actions");

var mapStateToProps = function mapStateToProps(_ref) {
  var versionsListReducer = _ref.versionsListReducer,
      fulfillmentConfigurationListReducer = _ref.fulfillmentConfigurationListReducer,
      componentShellReducer = _ref.componentShellReducer;
  return {
    isLoadingVersions: versionsListReducer.isLoadingVersions,
    availableVersions: versionsListReducer.availableVersions,
    selectedVersion: versionsListReducer.selectedVersion,
    selectedFulfillmentConfiguration: fulfillmentConfigurationListReducer.selectedFulfillmentConfiguration,
    environment: componentShellReducer.environment
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectVersion: function selectVersion(_ref2) {
      var versionId = _ref2.versionId,
          versionNumber = _ref2.versionNumber;
      return dispatch((0, _actions.selectVersion)({
        versionId: versionId,
        versionNumber: versionNumber
      }));
    },
    showFulfillmentConfigurationsList: function showFulfillmentConfigurationsList() {
      return dispatch((0, _actions2.showFulfillmentConfigurationsList)());
    },
    loadVersions: function loadVersions(_ref3) {
      var fulfillmentConfigurationId = _ref3.fulfillmentConfigurationId;
      return dispatch((0, _actions.loadVersions)({
        fulfillmentConfigurationId: fulfillmentConfigurationId,
        accessToken: ownProps.accessToken
      }));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_VersionsList["default"]);

exports["default"] = _default;